<template>
  <div>
    <div class="wrapper-image"
         :class="wrapperImageClass">
      <md-card-media class="card-media" v-for="(item, indexFile) in messageFiles"
                     :style="setSizeImage(messageFiles)" :key="indexFile" v-if="indexFile < 5">
        <span @click="showFileSlideShow(currentMess.files, indexFile)">
          <img class="cursor-pointer media-image"
            :class="{'border-none-sticker': isStickerMessage}"
            :src="mediaImageSrc(item)"
            loading="lazy"
            decoding="async"
            @error="onMediaImageError($event, item)">
          <span class="hd-quality"
                v-if="item.width >= 1920 || item.height >=1080">HD</span>
          <div class="countFile" v-if="indexFile == 4 && messageFiles.length - 5 > 0">
            <span class="totalCount">+ {{ messageFiles.length - 5 }}</span>
          </div>
        </span>
      </md-card-media>
    </div>
    <div class="emojis" v-if="displayEmoji && !hideFooter"
         @click="$modal.show('reaction-message-detail-modal', {message_id : currentMess.id})">
      <div v-for="(emoji_icon, icon) in currentMess.reaction_stats" v-if="emoji_icon > 0"
           :key="icon" class="emoji-wrapper">
        <span class="mr-2px text-300-medium neutral_3">{{ emoji_icon }}</span>
        <div :class="'reaction-' + icon" class="emoji_icon"></div>
      </div>
    </div>
    <div class="content-display-timestamp mt-5px mr-10px"
         v-if="!isMessageInBlock && !hideFooter">
      <span>{{ messageTime }}</span>
    </div>
  </div>
</template>

<script>
  import {helpers} from "../../../../../helper/helpers";
  import { resolveChatMediaDisplaySrc, fallbackChatMediaImageOnError } from "../../../../../helper/chatMediaDisplay";
  import { isChatStickerMessage } from "../../../../../helper/chatSystemNote";
  export default {
    name: "image-chat-content",
    components: {},
    props: {
      displayName: {
        type: String,
        default: "",
      },
      currentMess: {
        type: Object,
        default: () => {
          return {};
        }
      },
      nextMess: {
        type: Object,
        default: null
      },
      hideFooter: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      displayEmoji() {
        return helpers.sumEmoji(this.currentMess.reaction_stats) > 0
      },
      messageTime() {
        return helpers.getMessageTime(this.currentMess)
      },
      isMessageInBlock() {
        return helpers.checkMessageInBlock(this.currentMess, this.nextMess)
      },
      isStickerMessage() {
        return isChatStickerMessage(this.currentMess && this.currentMess.system_note);
      },
      messageFiles() {
        const files = this.currentMess && this.currentMess.files;
        return Array.isArray(files) ? files : [];
      },
      wrapperImageClass() {
        const count = this.messageFiles.length;
        if (count >= 1 && count <= 5) {
          return `wrapper-image${count}`;
        }
        return 'wrapper-image5';
      }
    },
    methods: {
      mediaImageSrc(item) {
        return resolveChatMediaDisplaySrc(item, { preferDirectPath: this.isStickerMessage });
      },
      onMediaImageError(event, item) {
        fallbackChatMediaImageOnError(event, item);
      },
      showFileSlideShow(files, index) {
        this.$modal.show('slide-show-modal', {items: files, activeId: index});
      },

      setSizeImage(image){

        if(typeof image == 'undefined' || (typeof image !== 'undefined' && image.length > 1)){
          return {};
        }

        // set size for message sticker
        if (this.isStickerMessage) {
          return {
            'width' :  '100px',
            'height' : '100px'
          };
        }

        const max_width = 450;
        const max_height = 450;

        const width_image = image[0].width;
        const height_image = image[0].height;

        if (width_image == null || height_image == null) {
          return {
            'width': `${max_width}px`,
            'height': `${max_height}px`,
          };
        }

        // giá trị set cho ảnh
        let renderWidth, renderHeight;
        // tỷ lệ gốc của ảnh
        let imageRatio = height_image/width_image
        let maxRatio = max_height/max_width

        //TH1
        if(width_image <= max_width && height_image <= max_height){
          return {
            'width' :  `${width_image}px`,
            'height' : `${height_image}px`
          };
        }
        //TH2
        if (imageRatio > 1.5) {
          renderWidth = max_width/imageRatio;
          return {
            'width' :  `${renderWidth}px`,
            'height' : `${max_height}px`,
          };
        }
        // TH2
        else if (width_image > max_width && height_image > max_height) {
          if (imageRatio <= maxRatio) {
            renderWidth = max_width;
            // tính tỷ lệ bo
            let tlb = width_image / renderWidth;
            renderHeight = parseInt(height_image / tlb);
          } else {
            renderHeight = max_height;
            // tính tỷ lệ bo
            let tlb = height_image / renderHeight;
            renderWidth = parseInt(width_image / tlb);
          }

          return {
            'width' : `${renderWidth}px`,
            'height' : `${renderHeight}px`
          };
        }
        //TH3
        else if (width_image > max_width && height_image < max_height){
          renderWidth = max_width;
          // tính tỷ lệ bo
          let tlb = width_image / max_width;
          renderHeight = parseInt(height_image / tlb);

          return {
            'width' : `${renderWidth}px`,
            'height' : `${renderHeight}px`
          };
        }
        // TH4:
        else if (width_image < max_width && height_image > max_height){
          renderHeight = max_height;
          // tính tỷ lệ bo
          let tlb = height_image / renderHeight;
          renderWidth = parseInt(width_image / tlb);

          return {
            'width' :  `${renderWidth}px`,
            'height' : `${renderHeight}px`
          };
        }

        return {};

      },
    }
  };
</script>
<style lang="scss">
.border-none-sticker{
  border: 0 !important;
}
</style>